<template>
  <wallet-card :style="computedOverflow">
    <template #header>
      <div title="Finished" class="finishedribbon" v-if="isFinished">
        <div title="Finished">Finished</div>
      </div>
      <span class="header__left">
        <img src="/assets/sf/image/icon_grad.png" class="header__icon" />
        <svg
          viewBox="0 0 70.745 70.745"
          class="header__icon__auto"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <linearGradient
            id="a"
            gradientUnits="objectBoundingBox"
            x1=".5"
            x2=".5"
            y2="1"
          >
            <stop offset="0" stop-color="#fdaae0" />
            <stop offset="1" stop-color="#82d7fd" />
          </linearGradient>
          <g
            fill="url(#a)"
            stroke="#fff"
            stroke-width="2"
            transform="matrix(.98162718 -.190809 .190809 .98162718 0 11.513)"
          >
            <circle cx="30.17" cy="30.17" r="30.17" stroke="none" />
            <circle cx="30.17" cy="30.17" fill="none" r="29.17" />
          </g>
          <g
            fill="#fff"
            transform="matrix(.5591929 -.82903757 .82903757 .5591929 11.248 42.205)"
          >
            <path
              d="m11.369 18.473a.942.942 0 0 0 -.71-1.562h-2.421c-.016-.24-.025-.481-.025-.725a10.936 10.936 0 0 1 18.44-7.961l3.415-3.995a16.187 16.187 0 0 0 -27.1 11.955c0 .242.006.484.017.725h-2.041a.942.942 0 0 0 -.71 1.562l4.6 5.278.966 1.11 3.47-3.98z"
            />
            <path
              d="m29.033 6.386-3.433-3.936-2.135-2.45-3.049 3.5-2.516 2.886a.942.942 0 0 0 .71 1.562h2.419a10.935 10.935 0 0 1 -17.614 7.878l-3.415 3.995a16.189 16.189 0 0 0 21.558-1.2 16.07 16.07 0 0 0 4.723-10.673h2.041a.942.942 0 0 0 .711-1.562z"
              transform="translate(9.043 9.008)"
            />
          </g>
        </svg>
      </span>
      <strong class="header__title"
        ><span class="header__title__accent">{{ itemData.title }}</span
        ><br /><span>Auto Compound</span></strong
      >
      <small class="header__note">
        {{ itemData.description }}
      </small>
      <span class="header__tag">Auto</span>
    </template>

    <template #body>
      <p class="apy">
        <em class="apy__label">APR：</em>
        <span class="apy__num">{{ toFormattedApr(itemData.apr) }}%</span>
      </p>

      <p class="recent-earn-profit">
        <em class="recent-earn-profit__label"
          >Recent {{ itemData.rewardTokenSymbol }} profit:</em
        >
        <popper
          :trigger="popperTriggerType"
          :options="{ placement: 'bottom-end' }"
          v-if="itemData.account.earnedDescription"
        >
          <div class="popper">
            <div
              class="popper__description"
              v-html="itemData.account.earnedDescription"
            ></div>
          </div>
          <span slot="reference" class="recent-earn-profit__num">{{
            $store.state.isLogin && itemData.account.earned >= 0
              ? toFormattedToken(itemData.account.earned)
              : "0.00000"
          }}</span>
        </popper>
        <span class="recent-earn-profit__num text-gray" v-else>{{
          $store.state.isLogin && itemData.account.earned >= 0
            ? toFormattedToken(itemData.account.earned)
            : "0.00000"
        }}</span>
      </p>
      <p class="unstake-lockup" v-if="itemData.account.staked == 0">
        <em class="unstake-lockup__label-unstaked">Unstake Lockup:</em>
        <span class="unstake-lockup__num">{{ unstakeLockupDuration }}</span>
      </p>
      <p
        class="unstake-lockup unstake-lockup-without-fee"
        :class="isUnstakable ? 'text-gray' : ''"
        v-else
      >
        <popper
          :trigger="popperTriggerType"
          :options="{ placement: 'bottom-start' }"
        >
          <div class="popper">
            <p class="popper__title">
              Unstaking fee {{ isUnstakable ? "--" : unlockUnstakeFee }}%
            </p>
            <div class="popper__description">
              <p>
                Only applies within
                {{ itemData.compoundWithdrawFeePeriodString }} of staking.
                Unstaking after
                {{ itemData.compoundWithdrawFeePeriodString }} will not include
                a fee. Timer resets every time you stake new
                {{ itemData.stakeTokenSymbol }} in the pool.
              </p>
            </div>
          </div>
          <em slot="reference" class="unstake-lockup__label"
            >{{ isUnstakable ? "--" : unlockUnstakeFee }}% unstaking fee
            until</em
          >
        </popper>
        <span class="unstake-lockup__num">{{ unstakeLockupDuration }}</span>
      </p>
      <p
        class="unstake-fee"
        :class="isUnstakable ? 'text-gray' : ''"
        v-if="itemData.account.staked == 0"
      >
        <em class="unstake-fee__label">Unstake Fee:</em>
        <span class="unstake-fee__num"
          >{{ isUnstakable ? "--" : unlockUnstakeFee }} %</span
        >
      </p>
      <p
        class="body-box body-box--staked"
        v-if="itemData.apr == 0 || isFinished"
      >
        <input-button :size="'large'" :disabled="true"
          >Connect Wallet</input-button
        >
      </p>
      <p class="body-box body-box--staked" v-else>
        <template
          v-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked > 0
          "
        >
          <span class="body-box__label"
            >{{ itemData.stakeTokenSymbol }} Staked (Compounding)</span
          >
          <em class="body-box__num">{{
            toFormattedToken(itemData.account.compoundStaked)
          }}</em>
          <span class="staked-buttons">
            <button class="staked-button" @click="withdraw(itemData)">
              <svg-icon class="icon" :icon="'minus'" />
            </button>
            <button
              class="staked-button"
              @click="deposit(itemData)"
              v-if="!isFinished"
            >
              <svg-icon class="icon" :icon="'plus'" />
            </button>
          </span>
        </template>
        <input-button
          v-else-if="
            $store.state.isLogin && !itemData.account.isApproved && !isFinished
          "
          :size="'large'"
          :is-loading="isLoading"
          :disabled="isLoading"
          @click="approve(itemData)"
          >{{ isLoading ? "Approving" : "Approve" }}</input-button
        >
        <input-button
          v-else-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked <= 0 &&
            !isFinished
          "
          :size="'large'"
          :disabled="isFinished"
          @click="deposit(itemData)"
          >STAKE</input-button
        >
        <input-button
          v-else
          :size="'large'"
          @click="openModal('modal-connect-wallet')"
          >Connect Wallet</input-button
        >
      </p>
    </template>

    <template #detail>
      <span class="detail__data__auto">
        <span class="detail__data__auto__badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="detail__data__auto__badge__icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span class="detail__data__auto__badge__text">Auto</span>
        </span>
        <span class="detail__data__auto__question-mark">
          <popper
            :trigger="popperTriggerType"
            :options="{ placement: 'bottom-center' }"
          >
            <div class="popper">
              <div class="popper__description">
                <p>
                  Any funds you stake in this pool will be automagically
                  harvested and restaked (compounded) for you.
                </p>
              </div>
            </div>
            <svg
              slot="reference"
              version="1.1"
              id="Layer_1"
              class="detail__data__auto__question-mark__icon"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256
			C512,114.509,397.504,0,256,0z M256,476.279c-121.462,0-220.279-98.816-220.279-220.279S134.538,35.721,256,35.721
			c121.463,0,220.279,98.816,220.279,220.279S377.463,476.279,256,476.279z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M248.425,323.924c-14.153,0-25.61,11.794-25.61,25.946c0,13.817,11.12,25.948,25.61,25.948
			c14.49,0,25.946-12.131,25.946-25.948C274.371,335.718,262.577,323.924,248.425,323.924z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M252.805,127.469c-45.492,0-66.384,26.959-66.384,45.155c0,13.142,11.12,19.208,20.218,19.208
			c18.197,0,10.784-25.948,45.155-25.948c16.848,0,30.328,7.414,30.328,22.915c0,18.196-18.871,28.642-29.991,38.077
			c-9.773,8.423-22.577,22.24-22.577,51.22c0,17.522,4.718,22.577,18.533,22.577c16.511,0,19.881-7.413,19.881-13.817
			c0-17.522,0.337-27.631,18.871-42.121c9.098-7.076,37.74-29.991,37.74-61.666S295.937,127.469,252.805,127.469z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </popper>
        </span>
      </span>
      <span class="detail__data__total">
        <span>Total staked:</span>
        <span
          >{{ toFormattedToken(itemData.totalStakingTokens) }}
          {{ itemData.stakeTokenSymbol }}</span
        >
      </span>

      <span class="detail__data__performance-fee">
        <popper
          :trigger="popperTriggerType"
          :options="{ placement: 'bottom-start' }"
        >
          <div class="popper">
            <div class="popper__description">
              <p>
                Subtracted automatically from each yield harvest and burned.
              </p>
            </div>
          </div>
          <span slot="reference" class="detail__data__performance-fee__label"
            >Performance Fee:</span
          >
        </popper>
        <span class="detail__data__performance-fee__value">2%</span>
      </span>

      <span class="detail__data__link"
        ><a :href="itemData.url" target="_blank"
          >View Contract<svg-icon class="icon" :icon="'new_window'" /></a
      ></span>
      <span class="detail__data__link"
        ><a href="#" @click.prevent="addToMetamask"
          >Add to Metamask<svg-icon class="icon" :icon="'new_window'" /><img
            src="/assets/sf/icon/wallet-metamask.svg"
            alt="metamask"
            class="wallet-icon" /></a
      ></span>
    </template>
  </wallet-card>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import SvgIcon from "@/components/atoms/SvgIcon";
import WalletCard from "@/components/molecules/LimitedSaunaStakingWalletCard";
import { addToMetamask, getPools } from "@/utils/limitedSaunaStaking";
import token from "@/domain/limitedSaunaStaking/token";
import { MAX_UINT256 } from "@/utils/constants";
import numFormat from "number-format.js";
import {
  intervalToDuration,
  isAfter,
  isBefore,
  fromUnixTime,
  differenceInCalendarDays,
  addSeconds,
} from "date-fns";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  name: "StakingCard",
  components: {
    InputButton,
    SvgIcon,
    WalletCard,
    popper: Popper,
  },
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDetail: false,
      isLoading: false,
      countDownInterval: null,
      unstakeLockupDuration: "00:00:00",
      checkStatusInterval: null,
      isUnstakable: false,
      popperTriggerType: "hover",
    };
  },
  computed: {
    unstakeLockupTime() {
      return fromUnixTime(this.itemData.account.withdrawableTime);
    },
    isUnstakeLocked() {
      if (this.itemData.withdrawConstrains.lockType == 0) {
        return false;
      }
      return isBefore(new Date(), this.unstakeLockupTime);
    },
    isUnstakeUnlockableWithFee() {
      return this.itemData.withdrawConstrains.lockType == 2;
    },
    unlockUnstakeFee() {
      return this.itemData.withdrawConstrains.unlockFee;
    },
    isFinished() {
      return this.itemData.isFinished;
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
    computedOverflow() {
      if (!this.isFinished) {
        return "overflow: visible;";
      }

      return "overflow: hidden;";
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    toFormattedApr(num) {
      return numFormat("#,##0.00", num);
    },
    toCurrency(num) {
      return numFormat("#,##0.00", num);
    },
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
    deposit(stakingPool) {
      this.$store.dispatch("deposit/updateStakingPool", stakingPool);
      this.account.balance == 0
        ? this.$store.dispatch("openModal", "get-token-modal")
        : this.$store.dispatch(
            "openModal",
            "limited-sauna-staking-stake-modal"
          );
    },
    withdraw(stakingPool) {
      this.$store.dispatch("withdraw/updateStakingPool", stakingPool);
      !this.isUnstakable
        ? this.$store.dispatch(
            "openModal",
            "limited-sauna-staking-unstake-lockup-modal"
          )
        : this.$store.dispatch(
            "openModal",
            "limited-sauna-staking-unstake-modal"
          );
    },
    approve(stakingPool) {
      this.isLoading = true;

      const accountAddress = this.account.address;

      let tokenContract = new this.web3.instance.eth.Contract(
        token.abi,
        token.contractAddress
      );

      tokenContract.methods
        .approve(stakingPool.stakeContractAddress, MAX_UINT256)
        .send({ from: accountAddress })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 3);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds) {
      this.checkStatusInterval = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatusInterval);
                this.completeTransaction();
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction() {
      getPools(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("limitedSaunaStakingPools/updatePools", result);

        this.isLoading = false;

        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Contract Enabled",
          message: `You can now stake in the ${this.itemData.stakeTokenSymbol} pool!`,
        });
      });
    },
    incompleteTransaction() {
      this.isLoading = false;

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Canceled",
        message: "Please try again and confirm the transaction.",
      });
    },
    async addToMetamask() {
      let isAdded = await addToMetamask(this.web3.instance);
      if (isAdded) {
        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Added Token",
          message: "Token has been added to metamask.",
        });
      }
    },
    durationToText(duration) {
      let days = duration.days;
      let hours = duration.hours;
      let minutes = duration.minutes;
      let seconds = duration.seconds;
      let months = duration.months;

      if (months > 0) {
        let currentDate = new Date();
        days = differenceInCalendarDays(
          addSeconds(
            currentDate,
            this.itemData.withdrawConstrains.withdrawInterval / 1000
          ),
          currentDate
        );
      }

      if (this.itemData.account.staked <= 0) {
        if (days > 0) {
          return `${days} day(s)`;
        }
        if (days == 0) {
          return `${this.addLeadingZero(hours)}:${this.addLeadingZero(
            minutes
          )}:${this.addLeadingZero(seconds)}`;
        }
      } else {
        if (days > 0) {
          if (hours == 0 && minutes == 0 && seconds == 0) {
            return `${days} day(s)`;
          } else {
            return `${days} day(s)`;
          }
        } else {
          return `${this.addLeadingZero(hours)}:${this.addLeadingZero(
            minutes
          )}:${this.addLeadingZero(seconds)}`;
        }
      }
    },
    countdown() {
      this.countDownInterval = setInterval(() => {
        if (this.itemData.account.staked <= 0) {
          this.isUnstakable = false;
          let duration = intervalToDuration({
            start: 0,
            end: this.itemData.withdrawConstrains.withdrawInterval,
          });
          this.unstakeLockupDuration = this.durationToText(duration);
        } else {
          if (isAfter(new Date(), this.unstakeLockupTime)) {
            this.isUnstakable = true;
            this.unstakeLockupDuration = "00:00:00";
          } else {
            this.isUnstakable = false;
            let duration = intervalToDuration({
              start: new Date(),
              end: this.unstakeLockupTime,
            });
            this.unstakeLockupDuration = this.durationToText(duration);
          }
        }
      }, 1000);
    },
    addLeadingZero(number) {
      if (number < 10) {
        return `0${number}`;
      }
      return number;
    },
  },
  mounted() {
    this.countdown();
    if (window.innerWidth <= 768) {
      this.popperTriggerType = "clickToOpen";
    }
  },
  beforeDestroy() {
    clearInterval(this.countDownInterval);
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.header {
  &__left {
    position: relative;
  }
  &__title {
    font-size: 1.8rem;
    font-weight: 800;
    grid-column: 2;
    line-height: 1.2;
    &__accent {
      font-size: 2rem;
      display: inline-block;
      background: $gradation-vertical;
      background-clip: text;
      color: transparent;
    }
  }
  &__note {
    font-weight: 600;
    color: $color-font-note;
    grid-row: 2;
    grid-column: 2;
    font-size: 1.2rem;
  }
  &__tag {
    font-size: 1.4rem;
    height: 28px;
    line-height: 24px;
    border: 2px solid;
    padding: 0 14px;
    border-radius: 16px;
    display: inline-block;
    font-weight: bold;
    grid-column: 3;
  }
  &__icon {
    width: 54px;
    height: 54px;
    display: block;
    border-radius: 50%;
    grid-row: 1/3;

    &__auto {
      position: absolute;
      width: 35px;
      height: 35px;
      top: 30px;
      left: 30px;
    }
  }
}
.body-box {
  display: grid;
  grid-template-columns: 1fr auto;

  &--earned {
    margin-top: 32px;
    margin-bottom: 40px;
  }
  &--staked {
    margin-bottom: 24px;
  }
  &__label {
    display: block;
    font-weight: 600;
    color: $color-primary;
    margin-bottom: 8px;
    grid-column: 1/3;
    font-size: 1.2rem;
  }
  &__num {
    font-size: 1.7rem;
    font-weight: 700;
    align-self: center;

    &.--none {
      color: $color-disabled;
    }
  }
  &__usd {
    font-size: 1.2rem;
    align-self: center;
    display: block;
    color: $gray1;

    &.--none {
      color: $color-disabled;
    }
  }
}
.apy {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;

  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.recent-earn-profit {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;
  margin-top: 30px;

  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
    text-decoration: underline dotted rgb(122, 110, 170);
    text-underline-offset: 0.1em;
  }
}
.earn {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;

  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.unstake-lockup {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;
  // margin-bottom: 30px;
  font-size: 1.6rem;

  &__label {
    font-weight: 600;
    text-decoration: underline dotted rgb(122, 110, 170);
    text-underline-offset: 0.1em;
    font-size: 1.5rem;
  }

  &__label-unstaked {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.unstake-lockup-without-fee {
  margin-bottom: 30px;
}
.unstake-fee {
  display: grid;
  grid-template-columns: 1fr auto;
  // margin-bottom: 0.5em;
  margin-bottom: 30px;
  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.staked-buttons {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr;
}
.staked-button {
  font-size: 0;
  background: $gradation-horizontal;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 3px;

  .icon {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    fill: var(--color_bg_parts);
  }
}
.detail {
  &__data {
    &__auto {
      display: flex;
      flex-direction: row;
      align-items: center;

      &__badge {
        font-size: 1.2rem;
        height: 32px;
        line-height: 28px;
        border: 2px solid;
        padding: 0;
        border-radius: 16px;
        font-weight: bold;
        margin-bottom: 0.5em;
        display: flex;
        align-items: center;
        width: 100px;
        margin-right: 5px;

        &__icon {
          width: 20px;
          height: 20px;
          margin-left: 10px;
        }
        &__text {
          margin-left: 10px;
        }
      }
      &__question-mark {
        &__icon {
          width: 20px;
          height: 20px;
          margin-bottom: 0.5em;
        }
      }
    }

    &__total {
      margin-bottom: 0.5em;
      display: flex;
      justify-content: space-between;
    }
    &__performance-fee {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      &__label {
        text-decoration: underline dotted rgb(122, 110, 170);
        text-underline-offset: 0.1em;
      }
    }
    &__link {
      display: block;
      text-align: right;

      &:not(:last-child) {
        margin-bottom: 1em;
      }
      a {
        color: $color-font-note;
      }
      .icon {
        width: 0.85em;
        height: 0.85em;
        fill: $color-link;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
      .wallet-icon {
        width: 1.5em;
        height: 1.5em;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
    }
  }
}
.finishedribbon {
  background-color: rgb(189, 194, 196);
  color: white;
  margin: 0px;
  padding: 6px 0px;
  position: absolute;
  right: -30px;
  top: -30px;
  text-align: center;
  transform: translateX(30%) translateY(0%) rotate(45deg);
  transform-origin: left top;
  width: 180px;
}

.finishedribbon::before {
  right: 100%;
}

.fimishedtape::after {
  left: 100%;
}

.finishedribbon > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 180px;
}

.wallet-card {
  background: var(--color_bg_parts);
  border-radius: 20px;
  box-shadow: 0 0 15px #ccc;
  position: relative;
  overflow: hidden;
}

.text-gray {
  color: $gray1;
}

.popper {
  text-align: left;
  display: inline-block;
  font-size: 1.2rem;
  max-width: 300px;
  background-color: #232429;
  color: $gray2;
  border-color: transparent;
  padding: 10px;
  border-radius: 10px;

  &__title {
    font-weight: 800;
    font-size: 1.2rem;
    margin-bottom: 0.5em;
  }
  &__description {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .font-bolder {
      font-weight: 700;
    }
  }
}
</style>

<style lang="css">
.popper .popper__arrow {
  border-color: transparent transparent #000 transparent !important;
}
</style>